import React, { useState } from 'react'
import { ModuleMarkerPropsType } from './types'

// Components
import ModuleLessonSeparator from '../ModuleLessonSeparator'
import Icon from '../Icon'

// Styles
import './styles.scss'

export default ({
  lessonId,
  index,
  active,
  onClick,
  withSeparator,
  type,
  color,
  isBlocked,
  isFinished,
  isAvailable,
  isJoined,
}: ModuleMarkerPropsType) => {
  if (!type) return null

  const [hover, setHover] = useState<boolean>(false)

  const getStatus = () => {
    if (!isAvailable) return 'time'
    if (isFinished) return 'complete'
    if (isBlocked) return 'blocked'
    if (isJoined) return 'joined'
    return 'default'
  }

  const showIndexStatuses = ['joined', 'default']

  return (
    <>
      <div
        className={
          withSeparator ? 'module__lessons-item last' : 'module__lessons-item'
        }
      >
        <div
          onClick={() => onClick(lessonId)}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          className={'outer'}
        >
          <div
            className={'outer__content'}
            style={type !== 'circle' ? { minHeight: 152 } : {}}
          >
            <Icon
              type={type}
              status={getStatus()}
              color={color}
              isFill={hover || active}
            />
            {showIndexStatuses.includes(getStatus()) ? (
              <div className={'index'}>{index}</div>
            ) : null}
          </div>
        </div>
      </div>
      {withSeparator ? <ModuleLessonSeparator /> : null}
    </>
  )
}
